module.exports = __webpack_public_path__ + "static/media/13.bdc2c4aa.png";